import { LoginForm, LoginRequest } from "@/ServerTypes/Membership";
import { Texts } from "@/ServerTypes/Texts";
import { PropertyPanel } from "@serenity-is/corelib";
import { ErrorHandling, isEmptyOrNull, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse, localText, htmlEncode, Authorization } from "@serenity-is/corelib/q";
import { hasPermission } from "../../../Administration/User/Authentication/Authorization";
import { PermissionKeys } from "../../../ServerTypes/Administration";

$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
    loginPanel.element.find('.forgot-password').appendTo('.field.Password');

    // Show / hide password toggle (dual SVG icons)
    var pwd = loginPanel["byId"]('Password') as JQuery;
    if (pwd && pwd.length && !pwd.parent().hasClass('password-wrap')) {
        pwd.wrap('<div class="password-wrap"></div>');
        var toggle = $('<button type="button" class="toggle-password" tabindex="-1" aria-label="Show password" aria-pressed="false">'
            + '<svg class="icon-show" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>'
            + '<svg class="icon-hide" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-6.5 0-10-8-10-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c6.5 0 10 8 10 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>'
            + '</button>');
        toggle.appendTo(pwd.parent());
        toggle.on('click', function () {
            var show = pwd.attr('type') === 'password';
            pwd.attr('type', show ? 'text' : 'password');
            toggle.toggleClass('is-visible', show);
            toggle.attr('aria-pressed', String(show));
            toggle.attr('aria-label', show ? 'Hide password' : 'Show password');
        });
    }

    if ((document.getElementById('IsPublicDemo') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val('admin').attr('placeholder', 'admin')
        loginPanel["byId"]('Password').val('serenity').attr('placeholder', 'serenity');
    }

    if ((document.getElementById('Activated') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val((document.getElementById('Activated') as HTMLInputElement)?.value);
        loginPanel["byId"]('Password').focus();
    }
});

class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }

    constructor(container: JQuery) {
        super(container);

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            var request = this.getSaveEntity();

            serviceCall({
                url: resolveUrl('~/Account/Login'),
                request: request,
                onSuccess: () => {
                    this.redirectToReturnUrl();
                },
                onError: (response: ServiceResponse) => {
                    if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                        window.location.href = response.Error.Arguments;
                        return;
                    }

                    if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                        notifyError(response.Error.Message);
                        $('#Password').focus();

                        return;
                    }

                    ErrorHandling.showServiceError(response.Error);
                }
            });
        });
    }

    protected redirectToReturnUrl() {
        var q = parseQueryString();
        var returnUrl = q['returnUrl'] || q['ReturnUrl'];
        if (returnUrl) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;

            //NationalFranchise
            //if (!Authorization.hasPermission(PermissionKeys.HeadQuartes) &&
            //    Authorization.hasPermission(PermissionKeys.Centers) &&
            //    Authorization.hasPermission(PermissionKeys.NationalFranchise)) {
            //    window.location.href = resolveUrl('~/');
            //    console.log("National");
            //    return;
            //}

            ////MasterFranchise
            //if (!Authorization.hasPermission(PermissionKeys.HeadQuartes) &&
            //    !Authorization.hasPermission(PermissionKeys.NationalFranchise) &&
            //    Authorization.hasPermission(PermissionKeys.LocalFranchise) &&
            //    Authorization.hasPermission(PermissionKeys.Centers) &&
            //    Authorization.hasPermission(PermissionKeys.MasterFranchise)) {
            //    console.log("MAster");
            //    window.location.href = resolveUrl('~/');
            //    return;
            //}

            ////Unit Franchise
            //if (!Authorization.hasPermission(PermissionKeys.HeadQuartes) &&
            //    !Authorization.hasPermission(PermissionKeys.MasterFranchise) &&
            //    !Authorization.hasPermission(PermissionKeys.NationalFranchise) &&
            //     Authorization.hasPermission(PermissionKeys.LocalFranchise)) {
            //    console.log("LocalFranchise");
            //    window.location.href = resolveUrl('~/');
            //}

            ////Program Coordinator
            //if (!Authorization.hasPermission(PermissionKeys.HeadQuartes) &&
            //    !Authorization.hasPermission(PermissionKeys.MasterFranchise) &&
            //    !Authorization.hasPermission(PermissionKeys.NationalFranchise) &&
            //    !Authorization.hasPermission(PermissionKeys.LocalFranchise) &&
            //    Authorization.hasPermission(PermissionKeys.ProgramCoordinator)) {
            //    console.log("LocalFranchise + ProgramCoordinator");
            //    window.location.href = resolveUrl('~/ELearning/UserClubs');
            //}
        }
        else {
            window.location.href = resolveUrl('~/');
        }
    }

    protected getTemplate() {
        return `
<div class="s-Panel p-4">
    <h5 class="text-center my-4">Login to your account</h5>
    <form id="~_Form" action="">
        <div id="~_PropertyGrid"></div>
        <div class="px-field">
            <button id="~_LoginButton" type="submit" class="btn btn-primary my-3 w-100">
                  ${htmlEncode(Texts.Forms.Membership.Login.SignInButton)}
            </button>
        </div>
    </form>
</div>  
`;
    }
}